export const couponRoutes = {
	couponIndex: '/coupons',
	couponAdd: '/coupons/add',
	couponHistory: (id?: string) => `/coupons/${id ?? ':id'}/history`,
	couponEdit: (id?: string) => `/coupons/${id ?? ':id'}`
} as const
